<template>
  <div>
    <WuMaoSaleOverview v-if="isWuMaoAccount" />
    <ChengKuangSaleOverview v-else />
  </div>
</template>
<script>
  import ChengKuangSaleOverview from './chengkuang/saleOverview.vue';
  import WuMaoSaleOverview from './wumao/saleOverview.vue';
  export default {
    name: 'saleOverview',
    components: {
      ChengKuangSaleOverview,
      WuMaoSaleOverview,
    },
  };
</script>

<style lang="scss" scoped></style>
